import { useEffect, useState } from "react";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
import {  Modal } from "react-bootstrap";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import VehicleListTabel from "../../Tables/Vehicle/VehicleListTabel";
import { AddVehicleApi, getVehicleListApi } from "../../../Api/PanelAdminServices";
import Button from "../../Button/Button";
const VehicleListContainer = () => {
  /////////get data //////
  const [CarListState, setCarListState] = useState([]);
  const [disable, setDisable] = useState(false);
  const [vehicleDetail, setVehicleDetail] = useState();
  useEffect(() => {
    DeliverList();
  }, []);
  const DeliverList = async () => {
    getVehicleListApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
            setCarListState(res.models);  
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  };
  const [deleteVisible, setDeleteVisible] = useState(false);
 


  const modalHandler = (data) => {
    setVehicleDetail(data)
    setDeleteVisible(true);
  };
  const handleOkAddress = () => {
    setDeleteVisible(false);
  };

  const deleteVehicleHandler=()=>{
    setDisable(true)
    let info={
      model:data.model,
      action:'delete',
      id:vehicleDetail.key
  }
  AddVehicleApi(info,(succ,res)=>{
      if(succ){
        setDisable(false)
          if(res.status===1){
              succToast('انجام شد!')
              DeliverList()
              handleOkAddress()
            }else{
              errorToast(res.message)
            }
      }else{
          console.log(res)
          setDisable(false)
      }
  })

  }


  const TitleStyle = {
    width: "100%",
    color: "#c20c64",
    textAlign: "center",
    fontSize:'1rem'
  };

  const data =
  CarListState &&
  CarListState.map((item) => {
    return {
      key: item.id,
      model: item.model,
    };
  });
  return (
    <div>
      <Modal show={deleteVisible} onHide={handleOkAddress}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>
            آیا از حذف کردن وسیله نقلبه موردنظر مطمئن هستید؟
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <Button
              ClassBtn={"rejectBtn"}
              Value={"خیر"}
              ClickHandler={handleOkAddress}
            />
            <Button
              ClassBtn={"confirmBtn"}
              Value={"بله"}
              ClickHandler={deleteVehicleHandler}
              disabledprops={disable}
            />
          </div>
        </Modal.Body>
      </Modal>

      <TableFixedPage title="لیست وسایل نقلیه" />
      <VehicleListTabel modalHandler={(data)=>modalHandler(data)} data={data} />
    </div>
  );
};

export default VehicleListContainer;
